var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAutomationMediaReplaceMediaUpload = function SvgIconAutomationMediaReplaceMediaUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.375 3.75A.375.375 0 0 0 21 3.375H10.5A4.125 4.125 0 0 0 6.375 7.5v21a4.125 4.125 0 0 0 4.125 4.125h15a4.125 4.125 0 0 0 4.125-4.125V13.72a.375.375 0 0 0-.375-.375H22.5a1.125 1.125 0 0 1-1.125-1.125zm-.328 16.254a1.126 1.126 0 1 0 1.406-1.758l-3.74-2.992c-.2-.164-.451-.254-.71-.254h-.012c-.254.002-.5.09-.697.249l-3.746 2.997a1.125 1.125 0 1 0 1.406 1.758l1.921-1.539v5.16a1.126 1.126 0 0 0 2.25 0v-5.16z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.625 4.236c0-.276.29-.451.504-.279q.273.22.484.513l4.52 6.296c.102.144-.009.33-.186.33H24a.375.375 0 0 1-.375-.375z"
  })));
};
export default SvgIconAutomationMediaReplaceMediaUpload;